/**
 * Utilitários para detecção de ambiente
 */

/**
 * Verifica se estamos em ambiente de desenvolvimento local
 */
export function isLocalDevelopment(): boolean {
  return (
    process.env.NODE_ENV === "development" &&
    (window.location.hostname === "localhost" ||
      window.location.hostname === "127.0.0.1" ||
      window.location.hostname === "0.0.0.0" ||
      window.location.hostname.startsWith("192.168.") ||
      window.location.hostname.startsWith("10.") ||
      window.location.hostname.startsWith("172."))
  );
}

/**
 * Verifica se estamos em ambiente de produção
 */
export function isProduction(): boolean {
  return process.env.NODE_ENV === "production";
}

/**
 * Verifica se estamos em ambiente de desenvolvimento (local ou não)
 */
export function isDevelopment(): boolean {
  return process.env.NODE_ENV === "development";
}

/**
 * Verifica se estamos em ambiente de teste
 */
export function isTest(): boolean {
  return process.env.NODE_ENV === "test";
}

/**
 * Obtém informações sobre o ambiente atual
 */
export function getEnvironmentInfo() {
  return {
    nodeEnv: process.env.NODE_ENV,
    hostname: window.location.hostname,
    isLocalDev: isLocalDevelopment(),
    isProduction: isProduction(),
    isDevelopment: isDevelopment(),
    isTest: isTest(),
  };
}

export default {
  isLocalDevelopment,
  isProduction,
  isDevelopment,
  isTest,
  getEnvironmentInfo,
};
